// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-type-teacher[data-v-ae3ea856] {\n  color: #2BA0AF;\n}\n[data-v-ae3ea856] .row-background-teacher {\n  background-color: #F4FDFD !important;\n}\n[data-v-ae3ea856] .row-background-family {\n  background-color: #FFF8F2 !important;\n}", ""]);
// Exports
module.exports = exports;
